import * as assert from "assert";

export interface IUserInfo {
    id: number;
    name: string;
    age: number;
    sex: string;
    created_at: string;
    email_address: string;
    firebase_uid: string;
    height_in_inches: number;
    is_admin: boolean;
}

export class UserInfo {
    id: number;
    name: string;
    age: number;
    sex: string;
    created_at: string;
    email_address: string;
    firebase_uid: string;
    height_in_inches: number;
    is_admin: boolean;

    public constructor(args: IUserInfo) {
        assert(undefined != args, 'UserInfo constructor passed null or undefined args object');
        assert(typeof args.id === 'number', 'UserInfo constructor passed args with invalid id');
        assert(typeof args.name === 'string', 'UserInfo constructor passed args with invalid name');
        assert(typeof args.age === 'number', 'UserInfo constructor passed args with invalid age');
        assert(typeof args.sex === 'string', 'UserInfo constructor passed args with invalid string');
        assert(typeof args.created_at === 'string', 'UserInfo constructor passed args with invalid created_at');
        assert(typeof args.email_address === 'string', 'UserInfo constructor passed args with invalid email_address');
        assert(typeof args.firebase_uid === 'string', 'UserInfo constructor passed args with invalid firebase_uid');
        assert(typeof args.height_in_inches === 'number', 'UserInfo constructor passed args with invalid height_in_inches');
        assert(typeof args.is_admin === 'boolean', 'UserInfo constructor passed args with invalid is_admin');

        this.id = args.id;
        this.name = args.name;
        this.age = args.age;
        this.sex = args.sex;
        this.created_at = args.created_at;
        this.email_address = args.email_address;
        this.firebase_uid = args.firebase_uid;
        this.height_in_inches = args.height_in_inches;
        this.is_admin = args.is_admin;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/data_layer/models/User.ts